import { DirectoryFormRow } from "./DirectoryFormRow";

interface IDisplacedDirectoryFormRowProps {
    labelKey?: string;
    children: JSX.Element | JSX.Element[];
    className?: string;
}

export function DisplacedDirectoryFormRow(props: IDisplacedDirectoryFormRowProps): JSX.Element {
    return (
        <DirectoryFormRow
            labelKey={props.labelKey}
            className={props.className}
        >
            {props.children}
        </DirectoryFormRow>
    );
}
